import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'
import { useTranslation } from 'react-i18next'

const InteractorCorrectionApproval = () => {
  const { t } = useTranslation()
  const correctionApproval = useCallback(
    (payload, reload) => {
      ApiService.jsonRequest('/transaction-correction-header/approval', payload, (response) => {
        if (response.status_code === 200) {
          showAlert({
            icon: 'success',
            message: t('response_message.correction_cancelled_success'),
            timer: 2000,
            reload: reload ?? true,
          })
        } else {
          showAlert({
            icon: 'warning',
            message: t('response_message.correction_cancelled_failed'),
            timer: 2000,
            reload: reload ?? true,
          })
        }
      })
    },
    [t],
  )
  return { correctionApproval }
}

export default InteractorCorrectionApproval
